import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function ThreePhases() {
  const revealRef = useScrollReveal();
  const phases = [{
    num: '01',
    name: 'EL QUIEBRE',
    title: 'El llamado del alma',
    text: 'Localizas el imán electromagnético del trauma en tu cuerpo y comienzas a desactivarlo. Tu crisis no es un error del universo. Es la señal más precisa que tu alma te ha enviado jamás.',
    accent: 'border-l-[#7B5CE8]'
  }, {
    num: '02',
    name: 'EL VACÍO',
    title: 'El útero cuántico',
    text: 'Aprendes a habitar el Punto Cero donde todo vuelve a ser posibilidad pura. Dejas de observar el problema para que deje de existir. El silencio se convierte en tu herramienta más poderosa.',
    accent: 'border-l-[#C9A96E]'
  }, {
    num: '03',
    name: 'EL SALTO',
    title: 'La autoridad cuántica',
    text: 'Con coherencia cerebro-corazón total, colapsar una nueva línea de tiempo. No deseas; eliges. No atraes; ordenas al campo de infinitas posibilidades.',
    accent: 'border-l-[#FAF7F2]'
  }];
  return <section className="bg-brand-violetDark py-10 px-[5%]" data-id="element-207">
      <div ref={revealRef} className="max-w-7xl mx-auto reveal" data-id="element-208">
        <div className="text-center mb-[56px]" data-id="element-209">
          <div className="text-brand-gold text-[11px] uppercase tracking-[0.15em] mb-4" data-id="element-210">
            EL PROTOCOLO
          </div>
          <h2 className="font-display italic text-[48px] text-brand-cream leading-tight" data-id="element-211">
            Tu transformación en 3 fases irreversibles
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-212">
          {phases.map((phase, i) => <div key={i} className={`bg-white/[0.03] border border-brand-gold/15 border-l-[3px] ${phase.accent} rounded-[20px] p-[40px_32px] transition-all duration-300 hover:-translate-y-[6px] hover:shadow-[0_20px_48px_rgba(0,0,0,0.4)]`} data-id="element-213">
              <div className="font-display font-light text-[72px] text-brand-gold opacity-15 leading-none mb-2" data-id="element-214">
                {phase.num}
              </div>
              <div className="font-body text-[11px] tracking-[0.15em] uppercase text-brand-gold mb-3" data-id="element-215">
                Fase {phase.num} — {phase.name}
              </div>
              <h3 className="font-display italic text-[26px] text-brand-cream mb-4" data-id="element-216">
                {phase.title}
              </h3>
              <p className="font-body text-[14px] text-brand-muted leading-[1.75]" data-id="element-217">
                {phase.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}